import { render, staticRenderFns } from "./FiltroDashboard.vue?vue&type=template&id=0c38dcf9"
import script from "./FiltroDashboard.vue?vue&type=script&lang=js"
export * from "./FiltroDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports